import useBellaPush from '../../../hooks/useBellaHistoryPush';
import useRouter from '../../../hooks/useRouter';
import { ListingPageUrlState } from '../../../redux/products/types';
import { convertUrlToListingPageState, convertListingPageStateToUrl } from '../services/listingPageUrlService';

export type SetListingPageStateFunc = (state: Partial<ListingPageUrlState>, resetPage?: boolean) => void;

export const getNewListingPageUrl = (
    oldState: ListingPageUrlState,
    updateState: Partial<ListingPageUrlState>,
    resetPage?: boolean
) => {
    const newState = {
        ...oldState,
        page: resetPage ? 1 : oldState.page,
        ...updateState,
    };

    return convertListingPageStateToUrl(newState);
};

const useListingPageUrlState = (): [ListingPageUrlState, SetListingPageStateFunc] => {
    const { location } = useRouter();
    const bellaPush = useBellaPush();

    const { pathname, search } = location;

    const listingPageState = convertUrlToListingPageState(pathname, search);

    const setListingPageState: SetListingPageStateFunc = (state, resetPage?: boolean) => {
        const url = getNewListingPageUrl(listingPageState, state, resetPage);
        bellaPush(url);
    };

    return [listingPageState, setListingPageState];
};

export default useListingPageUrlState;
